import { Container } from './Facility.container';

export default Container;
